import React from 'react';

import { FormField, Label, Listbox } from '@zillow/constellation';

import type { Section } from '../../../models/index';
import { METHAMPHETAMINE } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function Methamphetamine({ section, setSectionValues }: Props) {
  function onOptionChange(value: string): void {
    setSectionValues({
      [METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION]: value === METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION,
      [METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION]: value === METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION,
      [METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION]: value === METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION,
    });
  }

  return (
    <FormField
      label={<Label size="lg">Do you know of any methamphetamine contamination on the property?</Label>}
      control={
        <Listbox
          size="fluid"
          onChange={onOptionChange}
          appearance="radio"
          value={
            section.getFieldValue(METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION)
              ? METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION
              : section.getFieldValue(METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION)
                ? METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION
                : section.getFieldValue(METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION)
                  ? METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION
                  : ''
          }
          options={[
            {
              value: METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION,
              label: 'No contamination',
              meta: 'The property has no suspicion of contamination',
              disabled: section.isFieldDisabled(METHAMPHETAMINE.FIELD_NAME.NO_CONTAMINATION),
            },
            {
              value: METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION,
              label: 'In process of decontamination',
              meta: 'The property has been found to be contaminated above safe levels and is in the process of decontamination',
              disabled: section.isFieldDisabled(METHAMPHETAMINE.FIELD_NAME.DECONTAMINATION),
            },
            {
              value: METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION,
              label: 'Previous contamination',
              meta: 'The property has been found to be contaminated, but falls within safe levels after tests were conducted',
              disabled: section.isFieldDisabled(METHAMPHETAMINE.FIELD_NAME.PREVIOUS_CONTAMINATION),
            },
          ]}
        />
      }
    />
  );
}

Methamphetamine.description = 'Asks Irene whether or not there is meth contamination in the property';

export default Methamphetamine;
